import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel } from '@angular/router';
import { NgBackdropComponent } from './_shared/modules/ng-backdrop/ng-backdrop.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SVGPathMap, SELECTED_VENDOR, PRIVACY_POLICY_URL, TERMS_CONDITIONS_URL, StorageHelper, CustomEvents, Utils, CONFIGURABLE_DETAILS } from './_helpers';
import { NotificationsService } from './modules/trading/modules/profile/providers/notifications/notifications.service';
import { filter } from 'rxjs/operators';
import { BUILD_DEALER } from './_helpers/configuration';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService, EventsService } from './_shared/providers';
import { AuthRole, AuthService } from './modules/auth';
import { MixpanelService } from './_shared/providers/mixpanel/mixpanel.service';
import { CreditsExhaustedPopupComponent } from './_shared/modules/credits-exhausted-popup/credits-exhausted-popup.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

declare const dataLayer: any[];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // Ngx backdrop instance
  @ViewChild('loader', { static: true }) loader: NgBackdropComponent;
  SELECTED_VENDOR = SELECTED_VENDOR;
  socialIcons = SELECTED_VENDOR.socialIcons;
  legalLinks: { name: string, url: string }[] = [];
  BUILD_DEALER = BUILD_DEALER;
  isFromMobile: boolean = false;
  frontend_version: string;
  showSideNav: boolean = false;
  showNewFeatureAlert: boolean = false;
  AuthRole = AuthRole;

  dialogRef: MatDialogRef<CreditsExhaustedPopupComponent>;
  appName: string = CONFIGURABLE_DETAILS?.appName || 'uTrade Algos';

  // hidePlansAlert: boolean = false;

  constructor(
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public notificationsService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private configService: ConfigurationService,
    public authService: AuthService,
    private mixpanel: MixpanelService,
    private dialog: MatDialog,
    private events: EventsService,
  ) {
    this.frontend_version = this.configService.remoteConfigCacheObj.FRONTEND_VERSION || SELECTED_VENDOR.version;
    // this.hidePlansAlert = this.configService.remoteConfigCacheObj?.PLANS_CONFIG?.disablePlanAlerts;
    this.legalLinks = [
      {
        name: 'Privacy Policy',
        url: this.configService.remoteConfigCacheObj?.PRIVACY_POLICY_URL || PRIVACY_POLICY_URL,
      },
      {
        name: 'Terms of Use',
        url: this.configService.remoteConfigCacheObj?.TERMS_CONDITIONS_URL || TERMS_CONDITIONS_URL,
      }
    ];

    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Show loader when some navigation starts.
        if (this.loader) {
          this.loader.show();
        }
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        try {
          // When navigation ends or cancels hide the loader and scroll to top of page.
          document.getElementById('app-body').scrollTo(0, 0);
          if (this.loader) {
            this.loader.hide();
          }
        } catch (_) {
          console.log('app.component.ts:', _);
        }
      }

      if (event instanceof NavigationEnd) {
        this.mixpanel.init(); // safe, idempotent
      }
    });

    Object.keys(SVGPathMap).forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(SVGPathMap[icon])
      );
    });

    /** START : Code to Track Page View using GTM dataLayer */
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      dataLayer.push({
        event: 'page_view',
        page_path: event.urlAfterRedirects
      });
    })
    /** END : Code to Track Page View using GTM dataLayer */

    this.activatedRoute.queryParams.subscribe(params => {
      if ('fromMobile' in params) {
        this.isFromMobile = params['fromMobile'] === 'true';
        StorageHelper.fromMobile = this.isFromMobile;
      } else {
        this.isFromMobile = StorageHelper.fromMobile ?? false;
      }
    });
    // Fetch version from Go server

    this.events.subscribe(CustomEvents.CREDITS_EXHAUSTED, () => this.openCreditsExhaustedPopup());
  }

  ngOnInit(): void {
    Utils.clearCookies();
  }

  toggleNotificationSidenav() {
    if (this.notificationsService.isNotificationOpen) {
      this.notificationsService.toggleNotificationSidenav();
    }
  }

  openSideNav(bool: boolean) {
    this.showSideNav = bool;
  }

  openCreditsExhaustedPopup() {
    if (this.dialogRef) return;

    this.dialogRef = this.dialog.open(CreditsExhaustedPopupComponent, {
        width: '400px',
        panelClass: ['dialog-no-padding-rounded'],
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
}

  get headerTopOffset(): number {
    const alertHeight = 42; // Each alert is 42px tall
    
    // At a time only one notification is open
    if (this.authService.isNewFeatureAlert) {
      return alertHeight;
    }
    
    return 0;
  }

  get routerWrapperPaddingTop(): number {
    const headerHeight = 50; // Header is 50px tall
    return headerHeight + this.headerTopOffset;
  }
}
